// Typelizer digest 427fa054fde4e9d2b55760e14eadfd5e
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** DELETE /view_mode */
  destroy: (options?: RouteOptions): RouteDefinition<'delete'> => ({
    url: buildUrl('/view_mode', {}, options),
    method: 'delete',
  }),

  /** POST /view_mode */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/view_mode', {}, options),
    method: 'post',
  }),
}
